import React from 'react';

import styles from './PartnersLogosSection.module.css';

export const PartnersLogosSection = (props) => {
    return (
        <ul className={styles.partnersLogos}>
            {Array.isArray(props.logos) &&
                props.logos
                    .filter((item) => item !== null)
                    .map((item) => {
                        return (
                            <li key={item.id}>
                                <img
                                    alt={item.alternativeText}
                                    src={item.url}
                                    loading={props.loadingLazy ? 'lazy' : null}
                                    decoding={props.loadingLazy ? 'async' : null}
                                />
                            </li>
                        );
                    })}
        </ul>
    );
};
